import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { Button } from '@/components/shadcn/button'
import { IconV2SettingsOutline } from '@icons/IconV2SettingsOutline'
import {
  DMP_CHAT_TOOL_DISPLAY_OPTIONS,
  isDmpChatToolDisplayMode,
  type DmpChatToolDisplayMode,
} from '../dmpChatToolDisplay'

export function DmpChatToolDisplayMenu({
  mode,
  onModeChange,
}: {
  mode: DmpChatToolDisplayMode
  onModeChange: (mode: DmpChatToolDisplayMode) => void
}) {
  const selectedOption = DMP_CHAT_TOOL_DISPLAY_OPTIONS.find((option) => option.value === mode)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button aria-label={`Tool details: ${selectedOption?.label ?? 'Name only'}`} size="sm" variant="outline">
          <IconV2SettingsOutline aria-hidden="true" size={16} />
          <span className="hidden sm:inline">Tool details</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Tool activity details</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          onValueChange={(value) => {
            if (isDmpChatToolDisplayMode(value)) {
              onModeChange(value)
            }
          }}
          value={mode}
        >
          {DMP_CHAT_TOOL_DISPLAY_OPTIONS.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              <span>
                <span className="block">{option.label}</span>
                <span className="block text-xs text-muted-foreground">{option.description}</span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
